import {createAction} from '@ngrx/store';

export enum CookiePolicyActions {
  ShowCookieConsent = '[CookiePolicy Component] Show cookie consent dialog',
  HideCookieConsent = '[CookieConsent Component] Hide cookie consent dialog',
}
export const showCookieConsent = createAction(CookiePolicyActions.ShowCookieConsent);
export const hideCookieConsent = createAction(CookiePolicyActions.HideCookieConsent);
